<template>
  <div
    ref="slider"
    class="relative overflow-hidden pt-4 md:px-8 lg:px-16 px-4 animated-cards"
  >
    <div class="swiper-wrapper flex">
      <article
        v-for="(item, index) in items"
        :key="index"
        class="swiper-slide"
      >
        <!-- Product design -->
        <product-card
          v-if="item.cardView === 'product'"
          :model="item"
          :mobile="[415, 415]"
          :alt="item.name"
          width="415"
          height="415"
          @item-click="onItemClick(item)"
        />

        <!-- Recipe design -->
        <a
          v-if="item.cardView === 'recipe'"
          :href="item.url"
          class="h-0 flex flex-col justify-end relative group bg-center bg-no-repeat bg-cover pt-6/5"
          @click="onItemClick(item)"
        >
          <div
            v-if="item.preparationTime"
            class="absolute inline-flex top-0 left-0 ml-4 mt-4 items-center text-xs bg-blue-grey py-2 px-3 rounded-full mb-10 z-20 w-auto"
          >
            <span class="icon-clock ltr:mr-1 rtl:ml-1 text-blue-dark" />
            <span class="text-blue-dark">{{ item.preparationTime }}</span>
          </div>
          <Picture
            v-if="item.image"
            v-bind="item.image"
            :mobile="[640, 480]"
            width="640"
            height="480"
            img-class="absolute top-0 left-0 w-full h-full object-cover"
            :alt="item.name"
          />

          <div class="absolute inset-0 bg-gradient-black-to-transparant w-full pointer-events-none" />

          <div class="relative text-white p-4 group-hover:-translate-y-2 transform duration-200">
            <div class="text-white text-xl">{{ item.name }}</div>
          </div>
        </a>

        <featured-menu-item
          v-if="item.cardType === 'featuredMenuItem'"
          :model="item"
        />

        <story-card
          v-else-if="item.cardView !== 'recipe' && item.cardView !== 'product'"
          :model="item"
        />
      </article>
    </div>

    <div v-show="elementIsVisibleInViewport" class="swiper-pagination" />

    <button
      v-show="elementIsVisibleInViewport"
      class="swiper-button-prev"
    >
      <span class="icon-chevron-left relative z-20" />
    </button>
    <button
      v-show="elementIsVisibleInViewport"
      class="swiper-button-next"
    >
      <span class="icon-chevron-right relative z-20" />
    </button>
  </div>
</template>

<script>
// TODO Import swiper and only required modules
import Swiper from 'swiper/swiper-bundle'
import StoryCard from '@/components/story-card.vue'
import ProductCard from '@/components/products/ProductCard.vue'
import Picture from '@/components/Picture.vue'
import FeaturedMenuItem from '@/components/FeaturedMenuItem.vue'

export default {
  components: {
    FeaturedMenuItem,
    StoryCard,
    ProductCard,
    Picture
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    sliderTitle: {
      type: String,
      required: true
    },
    showNextSlideOnMobile: {
      type: Boolean,
      default: true
    },
    autoSlide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMobile: window.matchMedia('(max-width: 639px)').matches,
      isTablet: window.matchMedia('(min-width:640px) and (max-width: 1023px)').matches,
      isDesktop: window.matchMedia('(min-width:1024px) and (max-width: 1279px)').matches,
      isLargeDesktop: window.matchMedia('(min-width: 1280px)').matches
    }
  },
  computed: {
    isPagingVisibleOnMobile() {
      return this.isMobile && this.items.length > 1
    },
    isPagingVisibleOnTablet() {
      return this.isTablet && this.items.length > 2
    },
    isPagingVisibleOnDesktop() {
      return this.isDesktop && this.items.length > 3
    },
    isPagingVisibleOnLargeDesktop() {
      return this.isLargeDesktop && this.items.length > 4
    },
    elementIsVisibleInViewport() {
      return this.isPagingVisibleOnMobile || this.isPagingVisibleOnTablet || this.isPagingVisibleOnDesktop || this.isPagingVisibleOnLargeDesktop
    }
  },
  mounted() {
    let slidesPerView = document.documentElement.lang === 'ar' ? 1 : 1
    if (this.autoSlide) {
      slidesPerView = 'auto'
    }
    const settings = {
      initialSlide: 0,
      grabCursor: this.items.length > 1,
      slidesPerView,
      spaceBetween: 16,
      pagination: {
        el: '.swiper-pagination'
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        addIcons: false
      },
      breakpoints: {
        640: {
          grabCursor: this.items.length > 2,
          slidesPerView: 2,
          spaceBetween: 24
        },
        1024: {
          grabCursor: this.items.length > 3,
          slidesPerView: 3
        },
        1280: {
          grabCursor: this.items.length > 4,
          slidesPerView: 4
        }
      }
    }

    this.slider = new Swiper(this.$refs.slider, settings)

    this.slider.on('slideChange', () => {
      const trackingData = {
        event: 'sliderScroll',
        interactionType: (this.slider.swipeDirection === undefined) ? 'click' : 'swipe',
        sliderTitle: this.sliderTitle,
        direction: (this.slider.activeIndex > this.slider.previousIndex) ? 'right' : 'left'
      }
      window.dataLayer.push(trackingData)
    })
  },
  methods: {
    onItemClick(item) {
      const trackingData = {
        event: 'sliderItemClick',
        sliderTitle: this.sliderTitle,
        sliderItemTitle: item.name
      }

      window.dataLayer.push(trackingData)
    }
  }
}
</script>

<style>
.item-link:hover {
  .item-picture {
    img {
      transform: scale(1.05)
    }
  }
}
</style>
